import * as React from 'karet';
import './ClinicalSign.css';

export const ClinicalSign = ({ name }) => <span className="ClinicalSign">{name}</span>;
